import gql from "graphql-tag";

export const LOGIN_MUTATION = gql`
  mutation LoginUser(
    $username: String!
    $password: String!
  ) {
    login(
      input: {
        clientMutationId: "loginFormID"
        username: $username
        password: $password
      }
    ) {
      authToken
      refreshToken
      user {
        id
        name
        firstName
        lastName
        jwtAuthToken
        userId
      }
    }
  }
`;
